// extracted by mini-css-extract-plugin
module.exports = {"button":"_base-button_button_1_hTJ","clearfix":"_base-button_clearfix_3BGJC"};